import React, { memo, forwardRef } from "react";
const SvgDelta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.904 24.96c-1.136 0-2.152-.232-3.048-.696a5.22 5.22 0 01-2.112-1.968c-.496-.848-.744-1.84-.744-2.976 0-1.024.168-1.912.504-2.664a5.404 5.404 0 011.488-1.944c.656-.544 1.44-.992 2.352-1.344a12.42 12.42 0 01-1.08-.792 3.479 3.479 0 01-.864-1.056c-.224-.432-.336-.952-.336-1.56 0-.576.16-1.136.48-1.68.32-.56.824-1.016 1.512-1.368.688-.368 1.576-.552 2.664-.552.8 0 1.496.088 2.088.264.592.176 1.088.384 1.488.624.104.056.201.11.291.164.385.226.47.711.254 1.102-.286.52-.97.658-1.486.366a8.56 8.56 0 00-.715-.36 4.384 4.384 0 00-1.944-.432c-.672 0-1.2.096-1.584.288-.368.192-.624.432-.768.72a1.689 1.689 0 00-.216.792c0 .272.064.544.192.816.128.272.384.568.768.888.4.304.992.664 1.776 1.08 1.424.752 2.48 1.496 3.168 2.232.688.72 1.144 1.432 1.368 2.136.224.688.336 1.368.336 2.04 0 1.36-.272 2.472-.816 3.336a5.002 5.002 0 01-2.16 1.92 6.597 6.597 0 01-2.856.624zm.048-1.728c.8 0 1.472-.176 2.016-.528.56-.352.984-.84 1.272-1.464.288-.624.432-1.328.432-2.112s-.144-1.48-.432-2.088a4.807 4.807 0 00-1.248-1.608 7.83 7.83 0 00-1.872-1.2 9.257 9.257 0 00-1.656.744c-.48.288-.896.632-1.248 1.032-.336.384-.6.84-.792 1.368-.176.512-.264 1.096-.264 1.752 0 .816.152 1.536.456 2.16a3.7 3.7 0 001.32 1.44c.576.336 1.248.504 2.016.504z"
      />
    </svg>
  );
});
SvgDelta.displayName = "SvgDelta";
const MemoForwardRef = memo(SvgDelta);
export default MemoForwardRef;
